"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProductTile;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _bundleVariant = _interopRequireDefault(require("./bundle-variant.js"));
var _customerQuoteVariant = _interopRequireDefault(require("./customer-quote-variant.js"));
var _productListingContext = require("../product-listing-context");
var _productVariant = _interopRequireDefault(require("./product-variant.js"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* LOCAL */

/**
 * Render the product tile.
 * @module ProductTile
 *
 * @param {object} props React props
 * @param {string} props._name tracking name
 * @param {string} props.variant Render variant of the product tile
 * @returns {React.ReactElement} Product tile
 * @public
 */
function ProductTile(props) {
  const {
    activeCategory,
    dataCategory,
    selectorCustomProperties
  } = (0, _react.useContext)(_productListingContext.ProductListingContext);
  const {
    _name,
    id,
    variant,
    isFeaturedProductTile,
    featuredCategory,
    gridIndex,
    ...rest
  } = props;
  const renderAsHeroTile = isFeaturedProductTile && featuredCategory?.Text === activeCategory.name?.Text;
  const trackingName = `tile_${dataCategory}_${_name}`;
  const trackingCustomProperties = {
    ...selectorCustomProperties,
    plp_order: gridIndex
  };
  const trackingProps = {
    'id': `id-${id}`,
    '_name': _name,
    'data-cy': 'product-tile',
    'data-variant': renderAsHeroTile ? `featured-${variant}` : variant,
    ..._patternLibraryUtils.tracking.create(trackingName, false, false, trackingCustomProperties)
  };
  switch (variant) {
    case 'product':
      return /*#__PURE__*/_react.default.createElement(_productVariant.default, (0, _extends2.default)({
        renderAsHeroTile: renderAsHeroTile,
        gridIndex: gridIndex,
        trackingCustomProperties: trackingCustomProperties
      }, trackingProps, rest));
    case 'customer-quote':
      return /*#__PURE__*/_react.default.createElement(_customerQuoteVariant.default, (0, _extends2.default)({
        renderAsHeroTile: renderAsHeroTile
      }, rest, trackingProps));
    case 'bundle':
      return /*#__PURE__*/_react.default.createElement(_bundleVariant.default, (0, _extends2.default)({}, rest, trackingProps, {
        gridIndex: gridIndex,
        trackingCustomProperties: trackingCustomProperties,
        recommendedHeading: activeCategory.recommendedHeading,
        productHeading: activeCategory.productHeading
      }));
    case `none`:
    default:
      return null;
  }
}
ProductTile.propTypes = {
  _name: _propTypes.default.string,
  id: _propTypes.default.string,
  variant: _propTypes.default.string,
  isFeaturedProductTile: _propTypes.default.bool,
  featuredCategory: _propTypes.default.shape({
    Text: _propTypes.default.string
  }),
  gridIndex: _propTypes.default.number,
  trackingCustomProperties: _propTypes.default.object
};